/* Ezonzy theme — vanilla JS, no libraries.
   Works with Shopify's /cart AJAX API. Forms still post normally if JS fails. */
(function () {
  'use strict';

  var money = window.Ezonzy && window.Ezonzy.moneyFormat ? window.Ezonzy.moneyFormat : '${{amount}}';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    return money.replace(/\{\{\s*amount\s*\}\}/g, value)
                .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100));
  }

  /* ---------------- Overlay controller ---------------- */
  var backdrop = document.getElementById('backdrop');
  var openItems = [];

  function lock() { document.body.classList.add('body-lock'); }
  function unlock() { document.body.classList.remove('body-lock'); }

  function openEl(el) {
    if (!el) return;
    el.classList.add('open');
    if (backdrop) backdrop.classList.add('open');
    lock();
    if (openItems.indexOf(el) === -1) openItems.push(el);
  }
  function closeEl(el) {
    if (!el) return;
    el.classList.remove('open');
    openItems = openItems.filter(function (x) { return x !== el; });
    if (openItems.length === 0) { if (backdrop) backdrop.classList.remove('open'); unlock(); }
  }
  function closeAll() {
    openItems.forEach(function (el) { el.classList.remove('open'); });
    openItems = [];
    if (backdrop) backdrop.classList.remove('open');
    unlock();
  }
  if (backdrop) backdrop.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  function bindOpen(id, targetId, after) {
    var btn = document.getElementById(id);
    var target = document.getElementById(targetId);
    if (btn && target) btn.addEventListener('click', function () { openEl(target); if (after) after(); });
  }
  function bindClose(id, targetId) {
    var btn = document.getElementById(id);
    var target = document.getElementById(targetId);
    if (btn && target) btn.addEventListener('click', function () { closeEl(target); });
  }

  bindOpen('menuOpen', 'menuPanel');
  bindClose('menuClose', 'menuPanel');
  bindOpen('searchOpen', 'searchOverlay', function () {
    var i = document.getElementById('searchInput');
    if (i) setTimeout(function () { i.focus(); }, 120);
  });
  bindClose('searchClose', 'searchOverlay');

  document.querySelectorAll('.mobile-nav a').forEach(function (a) {
    a.addEventListener('click', function () { closeEl(document.getElementById('menuPanel')); });
  });

  /* ---------------- Cart drawer ---------------- */
  var cartPanel = document.getElementById('cartPanel');
  var cartBody = document.getElementById('cartDrawerBody');
  var cartCountEls = document.querySelectorAll('[data-cart-count]');

  function setCartCount(n) {
    cartCountEls.forEach(function (el) {
      el.textContent = n;
      if (n > 0) el.classList.add('show'); else el.classList.remove('show');
    });
  }

  function renderDrawer(cart) {
    if (!cartBody) return;
    if (!cart.items || cart.items.length === 0) {
      cartBody.innerHTML =
        '<div class="empty">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>' +
        '<h2>Your cart is empty</h2><p>Browse the shop to add your first item.</p>' +
        '<button class="btn btn-primary" data-close-cart>Continue shopping</button></div>';
      wireDrawer();
      return;
    }
    var rows = cart.items.map(function (item) {
      var img = item.image
        ? '<div class="pdc-image"><img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '"></div>'
        : '<div class="pdc-image"></div>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="pdc-variant">' + escapeHtml(item.variant_title) + '</div>' : '';
      return '<div class="pdc-row" data-key="' + item.key + '">' + img +
        '<div class="pdc-product"><div class="pdc-title">' + escapeHtml(item.product_title) + '</div>' + variant +
        '<div class="pdc-meta">Qty: ' + item.quantity + '</div>' +
        '<a href="#" class="pdc-remove" data-remove="' + item.key + '">Remove</a></div>' +
        '<div class="pdc-price">' + formatMoney(item.final_line_price) + '</div></div>';
    }).join('');
    cartBody.innerHTML =
      '<div class="pdc-stock"><i></i><span>Almost out of Stock</span></div>' +
      '<div class="pdc-lines">' + rows + '</div>' +
      '<div class="pdc-summary"><div class="pdc-subtotal"><span>Subtotal</span><strong>' + formatMoney(cart.total_price) + '</strong></div>' +
      '<p>Shipping and taxes calculated at checkout.</p>' +
      '<a href="/checkout" class="btn btn-primary btn-block pdc-checkout">Secure checkout</a>' +
      '<a href="/cart" class="btn btn-secondary btn-block pdc-view">View full cart</a></div>';
    wireDrawer();
  }

  function wireDrawer() {
    document.querySelectorAll('[data-close-cart]').forEach(function (b) {
      b.addEventListener('click', function () { closeEl(cartPanel); });
    });
    document.querySelectorAll('[data-remove]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        changeItem(a.getAttribute('data-remove'), 0);
      });
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function changeItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); renderDrawer(cart); })
      .catch(function () { window.location.href = '/cart'; });
  }

  var cartOpenBtn = document.getElementById('cartOpen');
  if (cartOpenBtn && cartPanel) {
    cartOpenBtn.addEventListener('click', function (e) {
      e.preventDefault();
      openEl(cartPanel);
      fetchCart().then(renderDrawer).catch(function () {});
    });
  }
  bindClose('cartClose', 'cartPanel');

  // initial count
  fetchCart().then(function (cart) { setCartCount(cart.item_count); }).catch(function () {});

  /* ---------------- Add to cart (product form) ---------------- */
  var pForm = document.getElementById('product-form');
  if (pForm) {
    pForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = pForm.querySelector('[name="add"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      var data = new FormData(pForm);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return fetchCart(); })
        .then(function (cart) {
          setCartCount(cart.item_count);
          renderDrawer(cart);
          openEl(cartPanel);
          if (btn) { btn.disabled = false; btn.textContent = original; }
        })
        .catch(function () { pForm.submit(); });
    });
  }

  /* ---------------- Variant selection ---------------- */
  var variantData = document.getElementById('variant-json');
  if (variantData) {
    var variants = JSON.parse(variantData.textContent);
    var selects = document.querySelectorAll('[data-option-index]');
    var idInput = document.getElementById('variant-id');
    var priceEl = document.getElementById('variant-price');
    var compareEl = document.getElementById('variant-compare');
    var addBtn = pForm ? pForm.querySelector('[name="add"]') : null;

    function currentOptions() {
      var opts = [];
      selects.forEach(function (s) { opts[parseInt(s.getAttribute('data-option-index'), 10)] = s.value; });
      return opts;
    }
    function updateVariant() {
      var opts = currentOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.style.display = '';
        } else { compareEl.style.display = 'none'; }
      }
      if (addBtn) {
        if (match.available) { addBtn.disabled = false; addBtn.textContent = 'Add to cart'; }
        else { addBtn.disabled = true; addBtn.textContent = 'Sold out'; }
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', updateVariant); });
  }

  /* ---------------- Quantity stepper ---------------- */
  document.querySelectorAll('.qty').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        val = b.getAttribute('data-dir') === 'up' ? val + 1 : Math.max(1, val - 1);
        input.value = val;
      });
    });
  });

  /* ---------------- Gallery thumbs ---------------- */
  document.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      var main = document.getElementById('gallery-main-img');
      if (main) main.src = t.getAttribute('data-full');
      document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
    });
  });

  /* ---------------- Accordions ---------------- */
  document.querySelectorAll('.accordion__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      var panel = btn.nextElementSibling;
      if (panel) panel.classList.toggle('open', !expanded);
    });
  });

  /* ---------------- Sort ---------------- */
  var sort = document.querySelector('.sort-select');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
})();
